module.exports = __webpack_public_path__ + "img/greencare.b66237f4.png";